/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types';
import { closeIcon } from 'assets/icons';
import { IconButton } from 'components';

import * as S from './ModalHeader.styled';

const ModalHeader = ({ title, close, message }) => {
  return (
    <>
      <S.Header>
        <S.HeaderTitle>{title}</S.HeaderTitle>
        <IconButton.SmallSizeBigIcon
          icon={closeIcon}
          type={IconButton.btnTypes.tertiary}
          onClick={close}
        />
      </S.Header>
      {message && <S.Message>{message}</S.Message>}
    </>
  );
};

ModalHeader.propTypes = {
  title: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
};

export default ModalHeader;
